<template>
  <div class="header">
    <div class="name">
      <h3>{{ isSpecific ? '面试确认' : '招聘进度' }}</h3>
    </div>
  </div>
  <el-empty v-if="!activityId" :image-size="140" description="暂无进行中的招聘"></el-empty>
  <template v-else>
    <!-- 专项招聘只需要面试确认 -->
    <div v-if="isSpecific">
      <div v-if="(recruit.interview == 0 && Date.now() > new Date(recruit.confirmDate[0])) || recruit.interview > 0" class="step_content">
        <div class="step_desc">
          <h2 style="margin-bottom: 10px; text-align: center">
            {{ recruit.status == 7 ? '您已确认参加面试' : recruit.status == 8 ? '您已放弃面试资格' : '' }}
          </h2>
          <p v-if="inConfirmDate && recruit.status < 10" class="blueTips">
            请在{{ recruit.confirmDate[0] }}至{{ recruit.confirmDate[1] }}点击确认是否参加面试
          </p>
          {{ inConfirmDate && recruit.status < 10 ? recruit.description : '' }}
          <!-- 在截止时间内可以反复点击参加和放弃，录用只能选择一次 -->
          <div v-if="inConfirmDate && recruit.status == 6" style="margin-top: 30px; text-align: center">
            <el-popconfirm
              confirm-button-text="确认放弃"
              confirm-button-type="danger"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="放弃后不可更改，请再次确认"
              @confirm="() => updateConfirmStatus(1)"
            >
              <template #reference>
                <el-button type="danger" size="medium">放弃</el-button>
              </template>
            </el-popconfirm>
            <el-button type="primary" size="medium" @click.stop="() => updateConfirmStatus(0)"> 确认参加 </el-button>
          </div>
        </div>
      </div>
      <el-empty v-else :image-size="140" description="面试确认暂未开始，请耐心等候通知"></el-empty>
    </div>
    <div v-else class="step_content">
      <el-steps :active="step" finish-status="success" process-status="finish" style="margin-top: 20px">
        <!-- 步骤1 -->
        <el-step :title="step == 0 ? '简历未投递' : '简历已投递'"></el-step>
        <!-- 步骤2 -->
        <el-step
          :title="
            recruit.status > 2 && Date.now() > new Date(recruit.confirmDate[0])
              ? '简历通过'
              : recruit.status == 2 && recruit.writtenExam == 1
              ? '简历未通过'
              : '简历筛选中'
          "
          :status="
            recruit.status > 2 && Date.now() > new Date(recruit.confirmDate[0])
              ? 'success'
              : recruit.status == 2 && recruit.writtenExam == 1
              ? 'error'
              : ''
          "
        ></el-step>
        <!-- 步骤3 -->
        <el-step
          :title="
            recruit.status == 5 || (recruit.status == 3 && (recruit.writtenExam == 1 || Date.now() > new Date(recruit.confirmDate[1])))
              ? '放弃笔试'
              : recruit.status == 4 && recruit.interview == 1
              ? '笔试未通过'
              : recruit.status > 5 && Date.now() > new Date(recruit.confirmDate[0])
              ? '笔试通过'
              : recruit.status == 3 && inConfirmDate
              ? '笔试待确认'
              : '进入笔试'
          "
          :status="
            recruit.status == 5 ||
            (recruit.status == 3 && (recruit.writtenExam == 1 || Date.now() > new Date(recruit.confirmDate[1]))) ||
            (recruit.status == 4 && recruit.interview == 1)
              ? 'error'
              : (recruit.status == 4 && Date.now() > new Date(recruit.confirmDate[0])) || recruit.status > 5
              ? 'success'
              : ''
          "
        ></el-step>
        <!-- 步骤4 -->
        <el-step
          :title="
            recruit.status == 8 || (recruit.status == 6 && Date.now() > new Date(recruit.confirmDate[1]))
              ? '放弃面试'
              : recruit.status == 7 && recruit.employment == 1
              ? '面试未通过'
              : recruit.status > 8 && Date.now() > new Date(recruit.confirmDate[0])
              ? '面试通过'
              : recruit.status == 6 && inConfirmDate
              ? '面试待确认'
              : '进入面试'
          "
          :status="
            recruit.status == 8 ||
            (recruit.status == 6 && Date.now() > new Date(recruit.confirmDate[1])) ||
            (recruit.status == 7 && recruit.employment == 1)
              ? 'error'
              : (recruit.status == 7 && Date.now() > new Date(recruit.confirmDate[0])) || recruit.status > 8
              ? 'success'
              : ''
          "
        ></el-step>
        <!-- 步骤5 -->
        <el-step
          :title="
            recruit.status == 13
              ? '未录用'
              : recruit.status == 12
              ? '录用'
              : recruit.status == 11 || (recruit.status == 9 && Date.now() > new Date(recruit.confirmDate[1]))
              ? '放弃考察和体检'
              : recruit.status == 9 && inConfirmDate
              ? '考察和体检'
              : recruit.status == 10
              ? '考察、体检中'
              : '进入考察和体检'
          "
          :status="
            recruit.status == 13 || recruit.status == 11 || (recruit.status == 9 && Date.now() > new Date(recruit.confirmDate[1]))
              ? 'error'
              : recruit.status == 12
              ? 'success'
              : ''
          "
        ></el-step>
      </el-steps>
      <div class="step_desc">
        <div v-if="step == 2 || step == 3 || step == 4">
          <h2 style="margin-bottom: 10px; text-align: center">
            {{ recruitmentStatus }}
          </h2>
          <p
            v-if="(recruit.writtenExam == 0 || recruit.interview == 0 || recruit.employment == 0) && inConfirmDate && recruit.status < 10"
            class="blueTips"
          >
            请在{{ recruit.confirmDate[0] }}至{{ recruit.confirmDate[1] }}点击确认是否{{
              recruit.writtenExam == 0 ? '参加笔试' : recruit.interview == 0 ? '参加面试' : '进入考察和体检'
            }}
          </p>
          {{
            (recruit.writtenExam == 0 || recruit.interview == 0 || recruit.employment == 0) && inConfirmDate && recruit.status < 11
              ? recruit.description
              : ''
          }}
          <!-- 在截止时间内可以反复点击参加和放弃，录用只能选择一次 -->
          <div
            v-if="(recruit.writtenExam == 0 || recruit.interview == 0 || recruit.employment == 0) && inConfirmDate && recruit.status < 10"
            style="margin-top: 30px; text-align: center"
          >
            <el-popconfirm
              confirm-button-text="确认放弃"
              confirm-button-type="danger"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              :title="recruit.status == 9 ? '放弃后不可更改，请再次确认' : '确认放弃吗？'"
              @confirm="() => updateConfirmStatus(1)"
            >
              <template #reference>
                <el-button :disabled="[5, 8].includes(recruit.status)" type="danger" size="medium">{{
                  recruit.status == 9 ? '放弃' : '确认放弃'
                }}</el-button>
              </template>
            </el-popconfirm>
            <el-button :disabled="[4, 7].includes(recruit.status)" type="primary" size="medium" @click.stop="() => updateConfirmStatus(0)">{{
              recruit.status == 9 ? '进入考察和体检' : '确认参加'
            }}</el-button>
          </div>

          <div v-if="recruit.status == 12 && recruit.offer === 1" style="margin-top: 30px; text-align: center">
            <el-button type="primary" size="medium" @click.stop="downloadNotice">下载录用通知函</el-button>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>
<script>
export default {
  name: 'Progress',
};
</script>

<script setup>
import { ElMessage, ElLoading } from 'element-plus';
import axios from 'axios';
import { onActivated, reactive, toRefs, watch, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import ApplicantApi from '../service/api/applicant';
import { getToken } from '../service/cookie';
import { compareInDate } from '../utils/tools';

const recruit = reactive({
  status: null,
  // null:未投递，0：已投递（未筛选），1：简历通过，2：简历未通过，3：笔试未确认，4：参加笔试，5：放弃笔试，6：面试未确认，7：参加面试，8：放弃面试，9：录用未确认，10：考察、体检中，11：放弃录用，12：录用，13：未录用
  confirmDate: [], // 笔试|面试|录用环节，所在轮次的确认时间范围['2024/01/01', '2024/01/30']
  writtenExam: -1, // 笔试环节状态：-1表示没有，0进行中，1已完成
  interview: -1,
  employment: -1,
  progressId: null, // 轮次ID
  description: '',
  offer: '', // offer下载链接
});

const store = useStore();
const isSpecific = computed(() => store.state.isSpecific); //是否是专项招聘
const activityId = computed(() => store.state.currentBatch?.activityId);
const userInfo = computed(() => store.state.userInfo);

// 招聘状态文字提示
const recruitmentStatus = computed(() => {
  const { status, employment, confirmDate } = recruit;
  if (status === 13) {
    return '考察和体检不合格';
  } else if (status === 12) {
    return '恭喜您已被录用';
  } else if (status === 11) {
    return '您已放弃进入下一环节';
  } else if (status === 10) {
    return '您已进入考察和体检环节，考察和体检合格后发送录用通知';
  } else if (employment > -1 && status > 8 && Date.now() > new Date(confirmDate[0])) {
    if (!inConfirmDate.value) {
      return '您超时未确认，已自动放弃进入下一环节';
    } else {
      return '您已通过面试，请确认是否参加考察和体检';
    }
  } else if (status === 9) {
    if (employment === 1) {
      return '';
    } else {
      return '面试已结束，如果面试通过，我们将与您联系';
    }
  } else if (status === 8) {
    return '您已放弃面试资格';
  } else if (status === 7) {
    if (employment === 1) {
      return '';
    } else if (employment === -1) {
      return '您已确认参加面试';
    } else if (employment === 0) {
      return '面试已结束，如果面试通过，我们将与您联系';
    }
  } else if (recruit.interview > -1 && recruit.status > 5 && Date.now() > new Date(recruit.confirmDate[0])) {
    if (!inConfirmDate.value) {
      return '您超时未确认，已自动放弃面试资格';
    } else {
      return '恭喜您进入面试确认环节';
    }
  } else if (recruit.status === 5) {
    return '您已放弃笔试资格';
  } else if (recruit.status === 4 || recruit.status === 6) {
    if (recruit.interview === 1) {
      return '';
    } else {
      return '您已确认参加笔试';
    }
  } else if (recruit.writtenExam > -1 && Date.now() > new Date(recruit.confirmDate[0])) {
    if (!inConfirmDate.value) {
      return '您超时未确认，已自动放弃笔试资格';
    } else {
      return '恭喜您进入笔试确认环节';
    }
  } else {
    return '';
  }
});
const inConfirmDate = computed(() => compareInDate(recruit.confirmDate[0], recruit.confirmDate[1]));
const step = computed(() => {
  const { status, confirmDate, writtenExam, interview, employment } = recruit;
  // 拟录用进行中，可能是第n轮拟录用，此时用户状态有null,0,1,2,3,4,5,6,7,8,9,10,11,12,13
  // 拟录用结束，此时用户状态有null,0,1,2,3,4,5,6,7,8,9,10,11,12,13
  if (employment > -1) {
    if (status > 11) return 4;
    if ([9, 10, 11].includes(status)) {
      if (inConfirmDate.value || Date.now() > new Date(confirmDate[1])) return 4; // 在确认时间范围内 | 在确认时间结束时间后
      if (Date.now() < new Date(confirmDate[0])) return 3; // 在确认时间开始时间前
    }
    if (status > 5) return 3;
    if (status > 2) return 2;
    if (status !== null) return 1;
  }
  // 面试确认开始，可能是第n轮面试确认，此时用户状态null,0,1,2,3,4,5,6,7,8
  // 面试确认结束，此时用户状态null,0,1,2,3,4,5,6,7,8
  if (interview > -1) {
    if (status > 8) return 3;
    if ([6, 7, 8].includes(status)) {
      if (inConfirmDate.value || Date.now() > new Date(confirmDate[1])) return 3; // 在确认时间范围内 | 在确认时间结束时间后
      if (Date.now() < new Date(confirmDate[0])) return 2; // 在确认时间开始时间前
    }
    if (status > 5) return 3;
    if (status > 2) return 2;
    if (status !== null) return 1;
  }
  // 笔试确认进行中，可能是第n轮笔试确认，此时用户状态有null,0,1,2,3,4,5
  // 笔试确认结束，此时用户状态有null,0,1,2,3,4,5
  if (writtenExam > -1) {
    if (status > 5) return 2;
    // 如果用户在当前轮次inConfirmDate，此时用户状态只有3,4,5
    if ([3, 4, 5].includes(status)) {
      if (inConfirmDate.value || Date.now() > new Date(confirmDate[1])) return 2; // 在确认时间范围内 | 在确认时间结束时间后
      if (Date.now() < new Date(confirmDate[0])) return 1; // 在确认时间开始时间前
    }
    if (status > 2) return 2;
    if (status !== null) return 1;
  }
  // 笔试轮次还未开始，此时用户状态只有undefined（接口请求失败）,null,0,1,2
  return status != null ? 1 : 0;
  /* 招聘进度文案
      1、writtenExam < 0
        简历未投递：step=0，简历未投递-简历筛选中-进入笔试-进入面试-进入考察和体检
          status=null
        简历已投递：step=1，简历已投递-简历筛选中-进入笔试-进入面试-进入考察和体检
          status=0
      2、writtenExam = 0
        笔试未确认：step=2，简历已投递-简历通过-笔试待确认-进入面试-进入考察和体检
          status=3，now=笔试轮次时间范围，可反复修改
        参加笔试：step=2，简历已投递-简历通过-进入笔试-进入面试-进入考察和体检
          status=4, now=笔试轮次时间范围，可反复修改
        放弃笔试：step=2，简历已投递-简历通过-放弃笔试-进入面试-进入考察和体检
          status=5, now=笔试轮次时间范围，可反复修改
      3、writtenExam = 1
        简历未通过：step=1，简历已投递-简历未通过-进入笔试-进入面试-进入考察和体检
          status=2
      4、interview = 0
        面试未确认：step=3，简历已投递-简历通过-笔试通过-面试待确认-进入考察和体检
          status=6，now=面试轮次时间范围，可反复修改
        参加面试：step=3，简历已投递-简历通过-笔试通过-进入面试-进入考察和体检
          status=7, now=面试轮次时间范围，可反复修改
        放弃面试：step=3，简历已投递-简历通过-笔试通过-放弃面试-进入考察和体检
          status=8, now=面试轮次时间范围，可反复修改
      5、interview = 1
        笔试未通过：step=2，简历已投递-简历通过-笔试未通过-进入面试-进入考察和体检
          status=4
      6、employment = 0
        拟录用未确认：step=4，简历已投递-简历通过-笔试通过-面试通过-录用待确认
          status=9，now=录用轮次时间范围
        接受录用：step=4，简历已投递-简历通过-笔试通过-面试通过-考察、体检中
          status=10, now=录用轮次时间范围，可反复修改
        放弃录用：step=4，简历已投递-简历通过-笔试通过-面试通过-放弃录用
          status=11, now=录用轮次时间范围，可反复修改
        录用通过：step=4，简历已投递-简历通过-笔试通过-面试通过-录用通过
          status=12
        录用不通过：step=4，简历已投递-简历通过-笔试通过-面试通过-未录用
          status=13
      7、employment = 1
        面试未通过：step=4，简历已投递-简历通过-笔试通过-面试未通过-进入考察和体检
          status=7
      */
});

const updateConfirmStatus = async (attendance) => {
  if (recruit.writtenExam != 0 && recruit.interview != 0 && recruit.employment != 0) return ElMessage.warning('确认环节已结束，不能再修改');
  if (!inConfirmDate) return ElMessage.warning('已超出当前确认截止范围，不能再修改');
  try {
    const res = await ApplicantApi.updateConfirmStatus({
      progressId: recruit.progressId,
      basicId: userInfo.value.basicId,
      attendance,
    });
    recruit.status = res.status;
    recruit.confirmDate = [res.startTime, res.endTime];
    recruit.writtenExam = res.writtenExam;
    recruit.interview = res.interview;
    recruit.employment = res.employment;
    recruit.progressId = res.progressId;
    recruit.description = res.description;
    recruit.offer = res.existOffer;
    ElMessage.success('修改成功');
  } catch (e) {
    ElMessage.error('修改失败，请稍后重试');
    console.error(e);
  }
};

//下载录取通知函
const downloadNotice = () => {
  if (!activityId.value) return ElMessage.warning('暂无招聘');
  const basicId = userInfo.value.basicId;
  const token = getToken();
  const headers = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const loadingInstance = ElLoading.service({
    text: '下载中...',
  });
  axios({
    url: `/prod-api/recruitment/applicant/downloadEntryZip?activityId=${activityId.value}&basicId=${basicId}`,
    method: 'get',
    headers,
    responseType: 'blob',
  })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: 'application/zip',
      });
      const url = window.URL.createObjectURL(blob); // 创建临时URL
      const link = document.createElement('a'); // 创建a标签
      link.href = url;
      link.download = '录用通知函.zip'; // 文件下载的默认名称
      link.click(); // 触发点击事件进行下载
      link.remove();
      window.URL.revokeObjectURL(url); // 释放临时URL资源
    })
    .catch((err) => {
      ElMessage.warning('下载失败');
      console.log(err);
    })
    .finally(() => {
      loadingInstance.close();
    });
};

let timer = null;
const init = async () => {
  if (timer) return;
  timer = setTimeout(async () => {
    clearTimeout(timer);
    timer = null;
    if (!userInfo.value || !userInfo.value.basicId) return;
    if (!activityId.value) return ElMessage.warning('暂无招聘');
    try {
      const res = await ApplicantApi.getRecruitProgress({
        activityId: activityId.value,
        basicId: userInfo.value.basicId,
      });
      recruit.status = res.status;
      recruit.confirmDate = [res.startTime, res.endTime];
      recruit.writtenExam = res.writtenExam;
      recruit.interview = res.interview;
      recruit.employment = res.employment;
      recruit.progressId = res.progressId;
      recruit.description = res.description;
      recruit.offer = res.existOffer;
      // recruit.status = 10;
      // recruit.confirmDate = ['2025-03-25 00:00:00', '2025-03-31 23:59:59'];
      // recruit.writtenExam = 1;
      // recruit.interview = 1;
      // recruit.employment = 0;
      // recruit.progressId = 13;
      // recruit.description = ``;
      // recruit.offer = '';
    } catch (e) {
      console.log(e);
      ElMessage.warning('暂无招聘进度');
    }
  }, 100);
};
watch(() => store.state.userInfo, init);
onActivated(init);
</script>

<style lang="scss" scoped>
@import '../style/func.scss';
.header {
  border-bottom: 1px solid rgba(112, 112, 112, 0.1);
  box-shadow: 0 0 4px #bebebe;
  padding: 10px 10px 6px 10px;
  font-size: 16px;
  .name {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  h3 {
    flex: 1;
    padding: 0 30px;
    white-space: nowrap;
  }
}
.step_content {
  width: 750px;
  margin: 100px auto;
  font-size: 15px;
  border: 1px solid #f7f7f7;
  box-shadow: 0 0 4px #bebebe;
  padding: 0 30px;
  .step_desc {
    font-size: 15px;
    margin: 30px auto;
    .blueTips {
      color: rgb(64, 158, 255);
      margin: rem(20px) 0;
      text-align: center;
    }
  }
}
@media screen and (max-width: 600px) {
  .step_content {
    width: 90%;
    margin: rem(30px) auto;
    .step_dec {
      .blueTips {
      }
    }
  }
}
</style>
